export const PROVIDER_TYPE_GOOGLE = 1;export const PROVIDER_TYPE_APPLE = 2;export const PROVIDER_TYPE_FACEBOOK = 3;export const PROVIDER_TYPE_BASIC = 5;